import React from 'react';
import { useLanguage } from '../utils/useLanguage';
import CarouselWithHeader from '../ui/CarouselWithHeader';
import { CarouselItem } from '../ui/CarouselWithHeader';
import ArticleCard from './ArticleCard';

export default function RelatedArticles({ articles, topics = [], authors = [] }) {
  const { t } = useLanguage();

  if (!articles || articles.length === 0) return null;

  const getTopic = (id) => topics.find(tp => tp.id === id);

  return (
    <CarouselWithHeader
      title={t('Hier geht´s weiter', 'Related articles')}
    >
      {articles.map(article => (
        <CarouselItem key={article.id} className="md:basis-1/2 lg:basis-1/3">
          <ArticleCard
            article={article}
            topic={getTopic(article.topic_id)}
            compact
          />
        </CarouselItem>
      ))}
    </CarouselWithHeader>
  );
}